<template>
  <q-page>
    <div class="q-pa-md" :style="cssVars">
      <div class="row q-mb-sm">
        <div class="col-12">
          <div class="row q-col-gutter-x-lg justify-between">
            <div class="col-shrink">
              <div class="page-title">
                <span class="q-mx-sm outcome-name">
                  {{ selectedOutcome.label }}
                </span>
                Action Centre
              </div>
            </div>
            <div>
              <outcome-options
                @outcomeSelect="selectOutcome"
                :showAllOption="true"
                :defaultAll="true"
              ></outcome-options>
            </div>
          </div>
        </div>
      </div>
      <div class="row q-col-gutter-x-lg" style="height: calc(100vh - 220px)">
        <div style="width: 225px">
          <!--FILTER-->
          <q-card class="shadow-10 sustainability-card-radius full-height">
            <q-card-section class="filterHeader outcome-theme-secondary">
              Actions
              <q-btn icon="mdi-help-circle" color="white" round flat> </q-btn>
            </q-card-section>
            <q-scroll-area
              :thumb-style="{
                background: '#162c479c',
                opacity: 1,
                width: '8px',
                height: '8px',
                borderRadius: '20px',
              }"
              style="height: calc(100% - 100px)"
            >
              <q-list class="q-mt-md q-pa-md">
                <q-card
                  class="no-shadow"
                  :class="{
                    cardSelected: filter.selected,
                  }"
                  style="margin-bottom: 20px"
                  v-for="(filter, i) in actionFilterOptions"
                  :key="i"
                >
                  <q-item dense @click="selectFilter(i)" clickable v-ripple>
                    <div class="row justify-between items-center full-width">
                      <div>
                        <span class="filter-text"> {{ filter.name }} </span>
                      </div>
                      <div>
                        <span class="filter-text"> 0 </span>
                      </div>
                    </div>
                  </q-item>
                </q-card>
              </q-list>
            </q-scroll-area>
          </q-card>
        </div>
        <div class="col q-mt-lg">
          <div class="row justify-between q-col-gutter-y-sm">
            <div class="col">
              <q-checkbox
                v-model="checkbox"
                style="margin: auto"
                class="outcome-secondary-color"
                @input="$refs.dtable.selectAll(checkbox)"
              ></q-checkbox>
              <q-img
                v-ripple
                @click="refresh"
                style="width: 18px; height: 20px; border-radius: 6px"
                src="statics/refresh-icon.svg"
              ></q-img>
              <q-btn
                flat
                color="black"
                padding="0px"
                icon="mdi-dots-vertical"
              ></q-btn>
            </div>
            <div class="co-12 q-mb-sm">
              <div class="row items-center">
                <span class="button-text q-mr-sm"> Sort By Due Date </span>
                <q-input
                  class="q-mr-md"
                  style="display: inline-block; width: 160px"
                  dense
                  v-model="sortByDate"
                  filled
                >
                  <template>
                    <q-popup-proxy
                      ref="date"
                      transition-show="scale"
                      transition-hide="scale"
                      :breakpoint="0"
                      v-model="calendarDialog"
                    >
                      <q-date
                        minimal
                        v-model="selectedDate"
                        default-view="Years"
                        emit-immediately
                        @input="checkCalendar"
                      >
                      </q-date>
                    </q-popup-proxy>
                  </template>
                </q-input>
                <div class="button-text">
                  Showing
                  <span class="text-bold">
                    {{ filteredActionsData.length }}
                  </span>

                  of {{ data.length }} Actions
                </div>
              </div>
            </div>
          </div>
          <div class="row full-width">
            <sustainability-data-table
              ref="dtable"
              style="height: calc(100vh - 250px)"
              class="shadow-10"
              :columns="columns"
              :data="filteredActionsData"
              :hideBottom="true"
              selected
              :headerBgColor="
                selectedOutcome.secondaryColor
                  ? selectedOutcome.secondaryColor
                  : '#162c47'
              "
              :isCustomHeader="true"
              updateBody
              selection="multiple"
              headerTextColor="white"
              :tickOnClick="false"
              @onSelected="checkAllSelected"
              @rowDoubleClick="() => {}"
            >
              <template slot="header" slot-scope="data">
                <q-tr :props="data.props" style="z-index: 100">
                  <template
                    v-for="col in data.props.cols"
                    v-bind:props="data.props"
                    :name="`header-cell-${col.name}`"
                  >
                    <q-th :key="col.name" :props="data.props">
                      <span
                        class="header-text-thin"
                        v-if="col.name == 'actions'"
                      >
                        {{ col.label }}
                      </span>
                      <span class="header-text" v-else>
                        {{ col.label }}
                      </span>
                    </q-th>
                  </template>
                </q-tr>
              </template>
              <template slot="body" slot-scope="data">
                <q-tr
                  class="bg-white text-black"
                  @click="$refs.dtable.handleClick(null, data.props.row)"
                  @dbclick="
                    $refs.dtable.handleDoubleClick(null, data.props.row)
                  "
                  :props="data.props"
                  style="z-index: 100"
                >
                  <template
                    v-for="column in data.props.cols"
                    :name="`body-cell-${column.name}`"
                    v-bind:props="data.props"
                  >
                    <q-td
                      @click="$refs.datatable.handleClick(null, data.props.row)"
                      @dblclick="doubleClickFromTR(null, data.props.row)"
                      style="width: 250px"
                      v-if="column.name == 'actions'"
                      :key="column.name"
                      :prop="data.props"
                    >
                      <div class="row items-center">
                        <div class="col-shrink">
                          <q-checkbox
                            class="outcome-secondary-color"
                            style="margin: auto"
                            v-model="data.props.selected"
                          >
                          </q-checkbox>
                        </div>
                        <div class="col" v-if="data.props.row.value">
                          <div class="action-cell-div">
                            <span class="action-cell">
                              {{ data.props.row.value }}
                            </span>
                            <q-tooltip v-if="data.props.row.value">
                              {{ data.props.row.value }}
                            </q-tooltip>
                          </div>
                        </div>
                      </div>
                    </q-td>
                    <q-td
                      v-else-if="column.name == 'assignedUser'"
                      :key="column.name"
                      :prop="data.props"
                    >
                      <div class="default-cell">
                        {{ data.props.row.userName }}
                      </div>
                    </q-td>
                    <q-td
                      v-else-if="column.name == 'status'"
                      :key="column.name"
                      :prop="data.props"
                    >
                      <div class="default-cell">
                        {{ data.props.row.status }}
                      </div>
                    </q-td>
                    <q-td
                      v-else-if="column.name == 'dueDate'"
                      :key="column.name"
                      :prop="data.props"
                    >
                      <div class="default-cell">
                        {{ data.props.row.dueBy | gridDateFormat }}
                      </div>
                    </q-td>
                    <q-td
                      v-else-if="column.name == 'lastUpdated'"
                      :key="column.name"
                      :prop="data.props"
                    >
                      <div class="default-cell" style="text-align: right">
                        <span>
                          {{
                            data.props.row.updated_at | momentFormatRelativeTime
                          }}
                        </span>
                        <q-btn
                          icon="mdi-lead-pencil"
                          :style="`color: ${cssVars['--outcome-secondary']}`"
                          flat
                        ></q-btn>
                      </div>
                    </q-td>
                  </template>
                </q-tr>
              </template>
            </sustainability-data-table>
          </div>
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
  import { mapGetters } from "vuex";
  import outcomeOptions from "@/components/outcomes/outcomeOptions.vue";
  import SustainabilityDataTable from "@/components/datatable/sustainabilityDatatable.vue";
  import moment from "moment";
  export default {
    mounted() {
      this.$store.dispatch("actions/loadAll");
    },
    components: {
      outcomeOptions,
      SustainabilityDataTable,
    },
    computed: {
      ...mapGetters({
        data: "actions/list",
      }),
      filteredActionsData() {
        if (this.selectedOutcome.hasOwnProperty("id")) {
          return this.data.filter(
            (e) => e.outcomes_id == this.selectedOutcome.id
          );
        } else {
          return this.data;
        }
      },
      sortByDate: {
        get() {
          if (this.userInput) {
            return moment(this.userInput).format("MMM, YYYY");
          } else {
            return "";
          }
        },
        set(newValue) {
          this.selectedDate = newValue;
          this.userInput = moment(newValue).format("MMM, YYYY");
        },
      },
      cssVars() {
        let primaryColorFaded = this.selectedOutcome.primaryColor
          ? this.selectedOutcome.primaryColor.split("#")
          : ["", "162c47"];
        let primaryColorFadedString = "#" + primaryColorFaded[1] + "80";
        return {
          "--outcome-primary": this.selectedOutcome.primaryColor
            ? this.selectedOutcome.primaryColor
            : "#162c47",
          "--outcome-secondary": this.selectedOutcome.secondaryColor
            ? this.selectedOutcome.secondaryColor
            : "#162c47",
          "--outcome-tertiary": this.selectedOutcome.tertiaryColor
            ? this.selectedOutcome.tertiaryColor
            : "#162c47",
          "--outcome-primary-faded": primaryColorFadedString,
        };
      },
      defaultCSSData() {
        return "font-family: 'Montserrat';font-style: normal;font-weight: 400;font-size: 14px;line-height: 17px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;";
      },
      columns() {
        return [
          {
            name: "actions",
            label: "Actions",
            align: "left",
            field: "value",
          },
          {
            name: "assignedUser",
            label: "Assigned User",
            align: "left",
            field: "userName",
          },
          {
            name: "status",
            label: "Status",
            align: "left",
            field: "status",
          },
          {
            name: "dueDate",
            label: "Due Date",
            align: "left",
            field: "dueBy",
            format: (val) => {
              return this.$options.filters.gridDateFormat(val);
            },
          },
          {
            name: "lastUpdated",
            label: "Last Updated",
            align: "right",
            field: "updated_at",
            format: (val) => {
              return this.$options.filters.momentFormatRelativeTime(val);
            },
          },
        ];
      },
    },
    data: () => ({
      //grid header filters
      checkbox: false,

      //calendar
      userInput: "",
      selectedDate: "",
      calendarDialog: false,

      selectedOutcome: {},
      actionFilterOptions: [
        {
          selected: false,
          name: "All Actions",
        },
        {
          selected: false,
          name: "Unread Actions",
        },
        {
          selected: false,
          name: "Read Actions",
        },

        {
          selected: false,
          name: "Overdue Actions",
        },
      ],
    }),
    methods: {
      checkAllSelected(selectedArray) {
        if (selectedArray.length != this.filteredActionsData.length) {
          this.checkbox = false;
        } else if (selectedArray.length == this.filteredActionsData.length) {
          this.checkbox = true;
        }
      },
      selectOutcome(outcome) {
        this.selectedOutcome = outcome;
      },
      selectFilter(index) {
        for (let i = 0; i < this.actionFilterOptions.length; i++) {
          this.actionFilterOptions[i].selected = false;
        }
        this.actionFilterOptions[index].selected = true;
      },
      refresh() {
        this.$store.dispatch("actions/loadAll");
      },
      checkCalendar(val, reason, details) {
        if (reason === "month") {
          this.userInput = moment(val).format("MMM, YYYY");
          this.calendarDialog = false;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .outcome-name {
    color: var(--outcome-primary);
  }

  .button-text {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 11.6054px;
  }

  .page-title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
    color: var(--outcome-secondary);
  }

  .categoryHeader {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 13px;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    color: #ffffff;
  }

  .cardSelected {
    border: 1px solid var(--outcome-primary);
    background-color: var(--outcome-primary-faded);
  }

  .filter-text {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: rgba(5, 0, 0, 0.5);
  }

  .action-cell-div {
    width: 170px;
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: normal;
  }

  .action-cell {
    color: var(--outcome-secondary);
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .default-cell {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .header-text {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
  }

  .header-text-thin {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 13px;
  }

  .outcome-secondary-color {
    color: var(--outcome-secondary);
  }

  .filterHeader {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 13px;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    color: #ffffff;
  }

  .outcome-theme-secondary {
    background-color: var(--outcome-secondary);
  }
</style>
